













































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { pick } from 'lodash';
import { PageResponse } from '@/core/typings/globals';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'page-seo',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      form: undefined,
    };
  },
  computed: {
    ...mapGetters({
      page: 'page/page',
    }),
  },
  methods: {
    async save() {
      try {
        await this.$store.dispatch('page/updatePage', {
          id: this.page.id,
          data: this.formToPage(this.form, this.page),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(
            error.response,
            `${this.$t(
              'PAGES.NOTIFICATIONS.FAILED_TO_UPDATED_A_PAGE'
            )}: ${error}`
          ),
          duration: -1,
        });
      } finally {
        this.$refs.form?.reset();
      }
    },
    formToPage(form, page) {
      return {
        ...page,
        ...form,
      };
    },
    pageToForm(page: PageResponse) {
      const form = pick(page, [
        'indexed',
        'description',
        'keywords',
        'og_image',
      ]);

      return form;
    },
  },
  created() {
    this.form = this.pageToForm(this.page);
  },
});
